import { SortSportEquipmentsColumnsEnum } from "./sort-sport-equipments-columns.enum";
import { SortDirectionEnum } from "./sort-direction.enum";
import { SportEquipmentListSortOrder } from "./sportEquipmentListSortOrder";

/**
 * Преобразует формат сортировки из enum в формат TypeORM
 * 
 * @param sortOrderModel - объект сортировки в формате { [SortSportEquipmentsColumnsEnum]: SortDirectionEnum }
 * @returns объект в формате TypeORM для передачи в GraphQL запрос
 * 
 * @example
 * // Входной формат:
 * { "sportZone": "ASC" }
 * 
 * // Выходной формат:
 * { sportZone: { name: "ASC" } }
 */
export function buildOrderBy(sortOrderModel: SportEquipmentListSortOrder): Record<string, any> | undefined {
  if (!sortOrderModel || Array.isArray(sortOrderModel) || typeof sortOrderModel !== 'object') {
    return undefined;
  }

  const result: Record<string, any> = {};

  // Проходим по всем ключам в sortOrderModel
  for (const [column, direction] of Object.entries(sortOrderModel)) {
    if (!direction) continue; // Пропускаем null/undefined значения

    const directionUpper = direction.toUpperCase() as SortDirectionEnum;

    // Маппинг enum значений на формат TypeORM
    switch (column) {
      // Простые поля (прямо в SportEquipmentEntity)
      case SortSportEquipmentsColumnsEnum.CREATED_AT:
        result.createdAt = directionUpper;
        break;
      
      case SortSportEquipmentsColumnsEnum.NAME:
        result.name = directionUpper;
        break;
      
      case SortSportEquipmentsColumnsEnum.INVENTORY_NUMBER:
        result.inventoryNumber = directionUpper;
        break;
      
      case SortSportEquipmentsColumnsEnum.TECHNICAL_CONDITION:
        result.technicalCondition = directionUpper;
        break;
      
      case SortSportEquipmentsColumnsEnum.COMMISSIONING_DATE:
        result.commissioningDate = directionUpper;
        break;

      // Связанные поля (через relations)
      case SortSportEquipmentsColumnsEnum.EQUIPMENT_TYPE:
        // Примечание: enum значение "equipment.equipmentType" преобразуется в { equipmentTypeObject: { name: ... } }
        // так как в TypeORM связь называется equipmentTypeObject
        result.equipmentTypeObject = { name: directionUpper };
        break;
      
      case SortSportEquipmentsColumnsEnum.SPORT_ZONE:
        result.sportZone = { name: directionUpper };
        break;
      
      case SortSportEquipmentsColumnsEnum.SPORT_SUBZONE:
        result.sportSubZone = { name: directionUpper };
        break;
      
      default:
        // Если поле не найдено в маппинге, используем как есть (для обратной совместимости)
        result[column] = directionUpper;
        break;
    }
  }

  // Возвращаем undefined если объект пустой
  return Object.keys(result).length > 0 ? result : undefined;
}

